import React, { FunctionComponent, SVGProps } from 'react'

export const IconBurger: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#FCFCFC"
    {...props}
  >
    <path
      d="M3.33203 10H16.6654"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33203 5H16.6654"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33203 15H16.6654"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
